// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"518f4917","100":"89553542","353":"0526e4e3","393":"d3aa309d","495":"4e4f9ee5","571":"83a20398","694":"18d0876a","839":"92579914","845":"57ff6dad","925":"c346c065","962":"9be29387"}[chunkId] + ".chunk.js";
};